import { render, staticRenderFns } from "./PackageSearch.vue?vue&type=template&id=b62a9d6c&scoped=true&"
import script from "./packagesearch.js?vue&type=script&lang=js&"
export * from "./packagesearch.js?vue&type=script&lang=js&"
import style0 from "./PackageSearch.vue?vue&type=style&index=0&id=b62a9d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62a9d6c",
  null
  
)

export default component.exports